import '/components/estate-attribute-table/estate-attribute-table.scss';
